import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Radio, Newspaper } from "lucide-react";
import SiteSwitcher from "@/components/SiteSwitcher";

/**
 * Top-level module switcher.
 * - Production module owns: /, /flux, /journal, /reglages
 * - Political-watch module owns: /veille, /veille/flux, /veille/reglages
 */
export default function ModuleSwitcher() {
  const { pathname } = useLocation();
  const isPolitics = pathname.startsWith("/veille");

  return (
    <div
      className="sticky top-0 z-40 bg-[var(--bg-app)] border-b border-[var(--border-default)]"
      data-testid="module-switcher"
    >
      <div className="max-w-2xl mx-auto flex items-center gap-1 p-2">
        <NavLink
          to="/"
          data-testid="switch-production"
          className={[
            "flex-1 flex items-center justify-center gap-2 min-h-[40px] px-3 text-[11px] uppercase tracking-widest font-mono border transition-colors",
            !isPolitics
              ? "bg-black text-white border-black"
              : "bg-white text-[var(--text-muted)] border-[var(--border-default)] hover:text-black hover:border-black",
          ].join(" ")}
        >
          <Newspaper className="w-4 h-4" strokeWidth={1.75} />
          <span>Production</span>
        </NavLink>
        <NavLink
          to="/veille"
          data-testid="switch-politics"
          className={[
            "flex-1 flex items-center justify-center gap-2 min-h-[40px] px-3 text-[11px] uppercase tracking-widest font-mono border transition-colors",
            isPolitics
              ? "bg-black text-white border-black"
              : "bg-white text-[var(--text-muted)] border-[var(--border-default)] hover:text-black hover:border-black",
          ].join(" ")}
        >
          <Radio className="w-4 h-4" strokeWidth={1.75} />
          <span>Recommandation d'actu</span>
        </NavLink>
        {!isPolitics && <SiteSwitcher />}
      </div>
    </div>
  );
}
